import { render, staticRenderFns } from "./TranslationOverrides.vue?vue&type=template&id=7754c121&scoped=true"
import script from "./TranslationOverrides.vue?vue&type=script&lang=js"
export * from "./TranslationOverrides.vue?vue&type=script&lang=js"
import style0 from "./TranslationOverrides.vue?vue&type=style&index=0&id=7754c121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754c121",
  null
  
)

export default component.exports